import "./style.css";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  INDUSTRY,
  SCHOOL,
  TEACHER,
  VISITOR,
  ADMIN,
  HELPDESK,
  VOLUNTEER,
  FACULTY,
  SPONSER_INDUSTRY,
  SPONSER,
} from "../../utils/constants";
import {
  getAllSponsors,
  getAllUsers,
  logoutUser,
} from "../../utils/firebase-config";
// import UsersTable from "../../components/table";
import UsersTable from "../../components/table";
import { Download } from "@mui/icons-material";
// import { browserHistory } from "react-router";

export default function ViewUsersPage() {
  const navigation = useNavigate();
  const location = useLocation();
  const [currentUser, setUser] = useState(null);
  const [selectedType, setSelectedType] = useState("Admin");
  const [users, setUsers] = useState([]);
  const [filterUsers, setFilterUsers] = useState([]);
  const [sponsers, setSponsers] = useState([]);

  const typesList = [
    "Admin",
    HELPDESK,
    FACULTY,
    VOLUNTEER,
    INDUSTRY,
    SCHOOL,
    TEACHER,
    VISITOR,
    SPONSER,
    SPONSER_INDUSTRY,
  ];

  useEffect(() => {
    if (location.state === null) {
      navigation("/");
    } else {
      setUser(location.state);
    }
  }, []);

  useEffect(() => {
    if (currentUser != null) {
      getAllUsers((data) => {
        console.log("Data Change ", data);
        setUsers(data);
      });
      getAllSponsors().then((data) => {
        setSponsers(
          data.map((obj, index) => ({
            ...obj,
            id: index + 1,
          }))
        );
      });
    }
  }, [currentUser]);
  useEffect(() => {
    const schoolList = users
      .filter((user) => user.type === SCHOOL)
      .map((obj, index) => ({
        ...obj,
        id: index + 1,
      }));
    console.log(schoolList);

    const teachersList = users
      .filter((user) => user.type === TEACHER)
      .map((obj, index) => ({
        ...obj,
        id: index + 1,
      }));
    let filterUserData;
    if (selectedType === FACULTY || selectedType === VOLUNTEER) {
      filterUserData = users
        .filter(
          (user) => user.type === VOLUNTEER && user.volunteer_type === "faculty"
        )
        .map((obj, index) => ({
          ...obj,
          lab_data: JSON.stringify(obj.lab_data),
        }));
    }
    if (selectedType === FACULTY) {
      filterUserData = users
        .filter(
          (user) => user.type === VOLUNTEER && user.volunteer_type === "faculty"
        )
        .map((obj, index) => ({
          ...obj,
          id: index + 1,
        }));
    } else if (selectedType === VOLUNTEER) {
      filterUserData = users
        .filter(
          (user) => user.type === VOLUNTEER && user.volunteer_type !== "faculty"
        )
        .map((obj, index) => ({
          ...obj,
          id: index + 1,
        }));
    } else {
      filterUserData = users
        .filter((user) => user.type === selectedType)
        .map((obj, index) => ({
          ...obj,
          id: index + 1,
        }));
    }

    if (selectedType === TEACHER) {
      const a = filterUserData
        .filter((user) => user.type === selectedType)
        .map((obj, index) => {
          let schoolDetailList = schoolList.filter(
            (school) => school.school_unique_code === obj.school_unique_code
          );

          let schoolFilter;

          if (schoolDetailList.length > 0) {
            schoolFilter = schoolDetailList[0];
          } else {
            schoolFilter = { school_name: "" };
          }

          return {
            ...obj,
            school: schoolFilter.school_name,
          };
        });
      filterUserData = a;
    }
    if (selectedType === SCHOOL) {
      const a = filterUserData
        .filter((user) => user.type === selectedType)
        .map((obj, index) => ({
          ...obj,
          teachers: teachersList.filter(
            (teacher) => teacher.school_unique_code === obj.school_unique_code
          ).length,
        }));
      filterUserData = a;
    }
    if (selectedType != SPONSER_INDUSTRY) {
      setFilterUsers(filterUserData);
    } else {
      setFilterUsers(sponsers);
    }
  }, [selectedType, users]);

  function downloadCSV() {
    let a;
    if (selectedType === FACULTY || selectedType === VOLUNTEER) {
      a = filterUsers.map((obj, index) => ({
        ...obj,
        lab_data: `${obj.lab_data !== undefined ? obj.lab_data.lab_name : "-"}`,
      }));
    } else {
      a = filterUsers;
    }
    console.log(a);
    const csvData = objectToCsv(a);
    console.log(csvData);
    var blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, `${selectedType}-${new Date()}.csv`);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `${selectedType}-${new Date()}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
  const objectToCsv = function (data) {
    const csvRows = [];

    /* Get headers as every csv data format
        has header (head means column name)
        so objects key is nothing but column name
        for csv data using Object.key() function.
        We fetch key of object as column name for
        csv */
    const headers = Object.keys(data[0]);

    /* Using push() method we push fetched
           data into csvRows[] array */
    csvRows.push(headers.join(","));

    // Loop to get value of each objects key
    for (const row of data) {
      const values = headers.map((header) => {
        const val = row[header];
        return `"${val}"`;
      });

      // To add, separator between each value
      csvRows.push(values.join(","));
    }

    /* To add new line for each objects values
           and this return statement array csvRows
           to this function.*/
    return csvRows.join("\n");
  };

  return (
    <div className="form-div-full-admin">
      {currentUser !== null && (
        <div
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <div className="title-admin">
            <div style={{ display: "flex", gap: "30px", alignItems: "center" }}>
              <p
                className="link-admin"
                onClick={() => {
                  navigation("/detail", { state: currentUser });
                }}
              >
                My Profile
              </p>
              <p
                className="link-admin"
                onClick={() => {
                  navigation("/dashboard", { state: currentUser });
                }}
              >
                Dashboard
              </p>
            </div>
            <h1>IIT-Delhi Openhouse, 2025</h1>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <button
                className="submit-btn"
                onClick={() => {
                  if (filterUsers.length === 0) {
                    window.alert("No data for selected type");
                    return;
                  }
                  downloadCSV();
                }}
              >
                Download CSV
              </button>
              <p
                className="link-admin"
                onClick={() => {
                  logoutUser()
                    .then(() => {
                      window.location.href = "/";
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                }}
              >{`Logout : ${currentUser.name}`}</p>
            </div>
          </div>
          <div className="custom-tab-admin">
            {typesList.map((tabs) => (
              <div
                className="tab"
                style={{
                  border:
                    selectedType === tabs ? "solid var(--text-color) 1px" : "0",
                  fontWeight: selectedType === tabs ? "bold" : "normal",
                }}
                onClick={() => {
                  setSelectedType(tabs);
                }}
              >
                {tabs}
              </div>
            ))}
          </div>
          {filterUsers.length > 0 && (
            <UsersTable
              users={filterUsers}
              type={selectedType}
              currentUser={currentUser}
            />
          )}
        </div>
      )}
    </div>
  );
}
